import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=19ff2bee"
import script from "./table-header.vue?vue&type=script&lang=js"
export * from "./table-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ff2bee')) {
      api.createRecord('19ff2bee', component.options)
    } else {
      api.reload('19ff2bee', component.options)
    }
    module.hot.accept("./table-header.vue?vue&type=template&id=19ff2bee", function () {
      api.rerender('19ff2bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/table/table-header.vue"
export default component.exports